/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatchCalculateRequest } from '../models/BatchCalculateRequest';
import type { BatchCalculateResponse } from '../models/BatchCalculateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OvenSetupTimeControllerService {
    /**
     * @param requestBody
     * @returns BatchCalculateResponse OK
     * @throws ApiError
     */
    public static calculateSetupTimeBatch(
        requestBody: BatchCalculateRequest,
    ): CancelablePromise<BatchCalculateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/oven-setup-times/calculate-batch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param resourceTypeId
     * @param fromProductId
     * @param toProductId
     * @returns number OK
     * @throws ApiError
     */
    public static calculateSetupTime(
        resourceTypeId: string,
        fromProductId: string,
        toProductId: string,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/oven-setup-times/calculate',
            query: {
                'resourceTypeId': resourceTypeId,
                'fromProductId': fromProductId,
                'toProductId': toProductId,
            },
        });
    }
}
